export const PAYMENT_ERROR_FRAGMENT = `
  fragment PaymentErrorFragment on PaymentError {
    field
    code
    message
  }
`
